"use client";

import { useEffect } from "react";

import { useSearchParams } from "next/navigation";

import { ClickServer } from "shared-lib/clickserver";
import { TRACKING_EVENTS } from "shared-lib/helpers/statsigFunctions";

export default function FuzzyMatchTracker({ slug }: { slug: string }) {
  const params = useSearchParams();

  useEffect(() => {
    const fuzzySlug = params.get("fuzzy");
    if (fuzzySlug) {
      ClickServer.track(TRACKING_EVENTS.fuzzy_match, {
        slug: slug,
        fuzzy: fuzzySlug,
      });
    }
  }, [params, slug]);

  return <></>;
}
